import { styled } from '@mui/material';
import { LinkDeliveryMethod } from '../../services/sendLinkManager';
import {
  ErrorIcon,
  LetterOpen,
  SadLetterOpen,
  SmsFailedToSendIcon,
  SmsSentIcon,
} from '../../icons';
import { FC } from 'react';

const StyledEmailSentIcon = styled(LetterOpen)(({ theme }) => ({
  width: theme.spacing(20),
  height: theme.spacing(15),
}));

const StyledEmailFailIcon = styled(SadLetterOpen)(({ theme }) => ({
  width: theme.spacing(20),
  height: theme.spacing(15),
}));

const StyledSmsSentIcon = styled(SmsSentIcon)(({ theme }) => ({
  width: theme.spacing(22),
  height: theme.spacing(12),
}));

const StyledSmsFailedToSendIcon = styled(SmsFailedToSendIcon)(({ theme }) => ({
  width: theme.spacing(20),
  height: theme.spacing(15),
}));

const QrCodeFailIcon = styled(ErrorIcon)(({ theme }) => ({
  width: theme.spacing(20),
  height: theme.spacing(15),
}));

interface FeedbackIconProps {
  success: boolean;
  deliveryMethod: LinkDeliveryMethod;
}

export const DeliveryMethodFeedbackIcon: FC<FeedbackIconProps> = ({
  success,
  deliveryMethod,
}) => {
  if (success) {
    switch (deliveryMethod) {
      case LinkDeliveryMethod.Email:
        return <StyledEmailSentIcon />;
      case LinkDeliveryMethod.Sms:
        return <StyledSmsSentIcon />;
    }
  }

  switch (deliveryMethod) {
    case LinkDeliveryMethod.Email:
      return <StyledEmailFailIcon />;
    case LinkDeliveryMethod.Sms:
      return <StyledSmsFailedToSendIcon />;
    case LinkDeliveryMethod.QrCode:
      return <QrCodeFailIcon />;
  }
};
